/**
 * @module IDEE/impl/style/Feature
 */
import Style from './Style';

/**
 * @classdesc
 * Esta clase se encarga de actualizar los objetos geográficos.
 * @api
 * @extends {IDEE.impl.style.Style}
 */

class Feature extends Style {
  /**
   * @api stable
   */
  // constructor(options, impl) {
  //   super(options, impl);
  // }
}

export default Feature;
